export default "__VITE_ASSET__DZXL4FYA__"